export enum Gender {
    MALE = 'männlich',
    FEMALE = 'weiblich',
    DIVERS = 'divers'
}